import { render, staticRenderFns } from "./BuyerForm.vue?vue&type=template&id=17c51817&scoped=true"
import script from "./BuyerForm.vue?vue&type=script&lang=js"
export * from "./BuyerForm.vue?vue&type=script&lang=js"
import style0 from "./BuyerForm.vue?vue&type=style&index=0&id=17c51817&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c51817",
  null
  
)

export default component.exports